



//export const url = 'http://localhost:5000/api/';
//export const url = 'http://localhost:5055/api/';
//export const url = 'https://localhost:44380/api/';
export const url = 'https://api.agahinaslefarda.ir/api/';
//const url = 'https://192.168.1.102:44380';



//const url = 'https://192.168.1.102:44380';
//const url=baseRequestApi();
async function baseRequest(req) {
    let response = await fetch(req);
    var responseBody = await response.json();
    if (response.ok)
        return responseBody;

    throw (responseBody);
}

export async function postJson(action, data) {
    let req = new Request(url + action, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    return baseRequest(req).then(d => d).catch(e => { throw (e) });
}

/* async function baseUserRequest(userRequest: Request, at?: string) {

    userRequest.headers.set('Authorization', 'Bearer ' + ((useLoginStore.getState().login?.accessToken) || at))
    const requestClone=userRequest.clone();
    let response = await fetch(userRequest);
    let responseBody;
    try {
        responseBody = await response.json();
    } catch (error) {
        console.info(error);
        responseBody = "false";
    }
    if (response.ok)
        return responseBody;
    if (response.status != 401)
        throw (responseBody);

    console.log('401')
    return refreshAccessTokenAndRetry(requestClone);
} */

/* export function userPost(action: string, data: object | string, at?: string) {

    const request = new Request(url + action, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        body:JSON.stringify(data)
    });
    return baseUserRequest(request, at).then(d => d).catch(e => { throw (e) });
}

export function UserPostQuery(action:string,data:object,surl?:string){
    const request = new Request((surl||url) + action + '?' + new URLSearchParams(data), {
        method: "POST",
    });
   console.log(request);
    return baseUserRequest(request).then(d => d).catch(e => { throw (e) });
}



export function userForm(action: string, data:FormData) {

    const request = new Request(url + action, {
        method: "POST",
        body:data
    });
    return baseUserRequest(request).then(d => d).catch(e => { throw (e) });
}
 */

export const postUrl = async (action, data,surl) => {
    const response = await fetch((surl||url) + action + '?' + new URLSearchParams(data), {
        method: "POST",
    })
    if (response.ok)
        return (await response.json());
    throw (response);
}




/* export async function userGet(action: string, params = '') {
    const request = new Request(url + action + params, { headers: { 'Authorization': 'Bearer ' + (useLoginStore.getState().login?.accessToken) } })
    const requestClone=request.clone();
    const response = await fetch(request)
    if (response.ok)
        return await response.json();
    if (response.status != 401) {
        throw (response);
    }
    if (response.status == 401) {return refreshAccessTokenAndRetry(requestClone); }
} */


/* async function refreshAccessTokenAndRetry(request: Request, action?: string, rData?: object | string) {
    console.log('401.....')
    console.log("refreshing token....")
    const { accessToken, refreshToken } = useLoginStore.getState().login;
    try {
        let data = await postUrl('/login/refresh-token', { accessToken: accessToken, refreshToken: refreshToken })
        localStorage.setItem("accessToken", data.data);
        useLoginStore.getState().update({ accessToken: data.data, refreshToken: refreshToken, isCompleteRegister: true });
        
        return sendRequestFromObj(request);
    } catch (e) {
        console.log(e);
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        useLoginStore.getState().update(null);
    }
    
} */
/* async function sendRequestFromObj(reRequest: Request) {
  
    reRequest.headers.set('Authorization', 'Bearer ' + (useLoginStore.getState().login?.accessToken))

    const response = await fetch(reRequest);
    if (response.ok) {
        return await response.json();
    }
    throw (response);
} */




